module.exports = __webpack_public_path__ + "img/webnew62.97e4bc85.jpg";